import Axios from 'axios';
import {API_URL} from '../../env'

const API = Axios.create({  
    baseURL:API_URL,     
     headers: {
       'Content-Type': 'application/json',
       'Accept': 'application/json',
       'XMLHttpRequest': 'XMLHttpRequest',                        
       'Club': `${localStorage.getItem('club_id')}`,            
       Authorization: {
        toString () {
          return `Bearer ${localStorage.getItem('access_token')}`
        }
      }
     }
});

API.interceptors.request.use(
  (config) => {
    const role = localStorage.getItem('role');
    if (role) {
      config.headers.Role = role;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default API;